/** @flow */

import { combineReducers } from "redux";
import absenceDetails, { initialState as absenceDetailsState } from "./absence-details";
import rtwDetails, { initialState as rtwDetailsState } from "./rtw-details";
import referralDetails, { initialState as referralDetailsState } from "./referral-details";
import absenceMonitoring, { initialState as absenceMonitoringState } from "./absence-monitoring";
import alertDetails, { initialState as alertDetailsState } from "./alert-details";
import miReports, { initialState as MiReportsState } from "./mi-reports";
import kpiCompliance, { initialState as KpiComplianceReportState } from "./kpi-compliance-report";

export const initialState = {
  absenceMonitoring: absenceMonitoringState,
  rtwDetails: rtwDetailsState,
  referralDetails: referralDetailsState,
  alertDetails: alertDetailsState,
  absenceDetails: absenceDetailsState,
  miReports: MiReportsState,
  kpiCompliance: KpiComplianceReportState,
};

export default combineReducers({
  absenceMonitoring,
  rtwDetails,
  referralDetails,
  alertDetails,
  absenceDetails,
  miReports,
  kpiCompliance,
});
